<template>
  <div height="100%">
    <app-navbar/>
    <v-content>
        <v-container fluid>          
          <v-layout row pb-2>
            <v-flex xs12>
              <v-card min-height="700px">
                <v-toolbar card prominent>
                  <v-toolbar-side-icon @click="mandat_drawer = ! mandat_drawer"><v-icon>filter_list</v-icon></v-toolbar-side-icon>
                  <v-toolbar-title class="body-2 grey--text">FILTRES</v-toolbar-title>

                  <v-spacer></v-spacer>

                  <span v-if="user_filter" class="font-weight-bold" color="primary">
                    MES MANDATS
                  </span>
                  <span v-if="!user_filter" class="font-weight-bold" color="primary">
                    TOUS LES MANDATS
                  </span>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" dark v-if="!user_filter" @click="user_filter=true">Mes Mandats</v-btn>
                  
                  <v-btn color="primary" dark v-if="user_filter" @click="user_filter=false">Tous les mandats</v-btn>
                  <v-btn color="primary" icon @click="open_mandat_creator()" ><v-icon>add</v-icon></v-btn>
                </v-toolbar>


                <v-navigation-drawer class="grey lighten-4" v-model="mandat_drawer" absolute clipped app temporary>
                  <v-list>
                    <v-list-tile>
                      <v-list-tile-title>Lieu</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile>

                        <v-text-field clearable prepend-icon="place" label="Ville" v-model="ville_filter"></v-text-field>
                    </v-list-tile>
                    <v-list-tile>
                        <v-text-field :mask="poste_mask" clearable prepend-icon="email" label="Code Postal" v-model="poste_filter"></v-text-field>
                    </v-list-tile>
                    <v-list-tile>
                      <v-list-tile-title>Bien</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile>
                      <v-select prepend-icon="home" v-model="type_filter" :items="types_biens" label="Types" multiple></v-select>
                    </v-list-tile>
                    <v-list-tile>
                      <v-layout row>
                      <v-flex md8 class="pr-3">
                        <v-text-field :mask="budget_mask" clearable prepend-icon="attach_money" label="prix de" v-model="budget_min"></v-text-field>
                      </v-flex>
                      <v-flex md4>
                        <v-text-field :mask="budget_mask" clearable label="à" v-model="budget_max"></v-text-field>
                      </v-flex>
                      </v-layout>
                    </v-list-tile>
                    <v-list-tile>
                      <v-layout row>
                      <v-flex md8 class="pr-3">
                        <v-text-field :mask="room_mask" clearable prepend-icon="meeting_room" label="pièces de" v-model="room_min"></v-text-field>
                      </v-flex>
                      <v-flex md4>
                        <v-text-field :mask="room_mask" clearable label="à" v-model="room_max"></v-text-field>
                      </v-flex>
                      </v-layout>
                    </v-list-tile>
                    <v-list-tile>
                      <v-layout row>
                      <v-flex md8 class="pr-3">
                        <v-text-field :mask="room_mask" clearable prepend-icon="hotel" label="chambres de" v-model="bed_min"></v-text-field>
                      </v-flex>
                      <v-flex md4>
                        <v-text-field :mask="room_mask" clearable label="à" v-model="bed_max"></v-text-field>
                      </v-flex>
                      </v-layout>
                    </v-list-tile>
                    <v-list-tile>
                      <v-layout row>
                        <v-flex md8 class="pr-3">
                          <v-text-field :mask="surface_mask" clearable prepend-icon="aspect_ratio" label="surface de" v-model="surface_min"></v-text-field>
                        </v-flex>
                        <v-flex md4>
                          <v-text-field :mask="surface_mask" clearable label="à" v-model="surface_max"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-list-tile>
                  </v-list>
                </v-navigation-drawer>
                  <v-card flat v-for="mandat in mandats" :key="mandat.id" @click.stop="open_dialog(mandat)">
                    <v-layout v-if="(ville_filter==null || mandat.ville.includes(ville_filter))
                    &&(poste_filter==null || mandat.code_postal.includes(poste_filter))
                    &&(type_filter.length==0 || type_filter.includes(mandat.type_bien))                    
                    &&(isNaN(parseInt(budget_min)) || parseInt(budget_min) <= mandat.prix)
                    &&(isNaN(parseInt(budget_max)) || parseInt(budget_max)==0 || parseInt(budget_max) >= mandat.prix)
                    &&(isNaN(parseInt(room_min)) || parseInt(room_min) <= mandat.nombre_piece)
                    &&(isNaN(parseInt(room_max)) || parseInt(room_max)==0 || parseInt(room_max) >= mandat.nombre_piece)
                    &&(isNaN(parseInt(bed_min)) || parseInt(bed_min) <= mandat.nombre_chambres)
                    &&(isNaN(parseInt(bed_max)) || parseInt(bed_max)==0 || parseInt(bed_max) >= mandat.nombre_chambres)
                    &&   ((mandat.surface_logement!=null)&&(mandat.surface_logement!='')&&( isNaN(parseInt(surface_min)) || parseInt(surface_min) <= mandat.surface_logement) 
                      || (((mandat.surface_logement==null)||(mandat.surface_logement==''))&&(isNaN(parseInt(surface_min)) || parseInt(surface_min) <= mandat.surface_terrain)))
                    &&   ((mandat.surface_logement!=null)&&(mandat.surface_logement!='')&&(isNaN(parseInt(surface_max)) || parseInt(surface_max)==0 || parseInt(surface_max) >= mandat.surface_logement) 
                      || (((mandat.surface_logement==null)||(mandat.surface_logement==''))&&(isNaN(parseInt(surface_max)) || parseInt(surface_max)==0 || parseInt(surface_max) >= mandat.surface_terrain)))
                    && (user_filter==false || (mandat.vendeur_agence!=null&&(user==(mandat.vendeur_agence.first_name+' '+mandat.vendeur_agence.last_name))))"                       
                    row wrap justify-spasce-between :class="`mandat ${mandat.status}` ">
                      <v-flex xl2 lg4 md4 sm6 xs12>
                        <v-card tile flat class ="ml-1 my-1">
                          <v-img v-if="mandat.photos.length>0" :src="mandat.photos[0].photo" height="150px" width="225px">
                          </v-img>
                          <v-img v-if="mandat.photos.length==0" src="https://vignette.wikia.nocookie.net/mario-kart-fanon/images/d/d3/No-picture.jpg/revision/latest?cb=20151202231035&path-prefix=fr" height="150px" width="225px">
                          </v-img>
                        </v-card>
                      </v-flex>
                      <v-flex xl2 lg4 md4 sm6 xs12>
                        <v-card tile flat>
                          <v-card-text>
                            <span class="font-weight-bold">
                            {{mandat.type_bien}} <br/>
                            {{mandat.prix}}€<br/> </span>
                             <span class="font-weight-bold" v-if="mandat.surface_logement!=='' && mandat.surface_logement!==null">{{Math.round(mandat.prix/mandat.surface_logement)}}</span>
                            <span v-else class="font-weight-bold">{{Math.round(mandat.prix/mandat.surface_terrain)}}</span> € / m² <br/>
                            {{mandat.code_postal}} {{mandat.ville}} 
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xl2 lg2 md2 sm6 xs6>
                        <v-card tile flat>
                          <v-card-text>
                            <span class="font-weight-bold">{{mandat.nombre_piece}}</span> pieces<br/>
                            <span class="font-weight-bold">{{mandat.nombre_chambres}}</span> chambre <br/>
                            <span v-if="mandat.surface_logement!=='' && mandat.surface_logement!==null"><span class="font-weight-bold">{{mandat.surface_logement}}</span> m²<br/></span>
                            <span v-if="mandat.surface_terrain !=='' && mandat.surface_terrain!==null"><span class="font-weight-bold">{{mandat.surface_terrain}}</span> m² de terrain</span>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xl2 lg4 md4 sm6 xs6>
                        <v-card tile flat>
                          <v-card-text>
                            <span>Réf. : <span class="font-weight-bold">{{mandat.reference}}</span></span>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xl2 lg4 md4 sm6 xs6>
                        <v-card tile flat>
                          <v-card-text>
                           <v-icon>account_circle</v-icon><span class="font-weight-bold" v-if="mandat.vendeur_agence!=null">{{" "+ mandat.vendeur_agence.first_name + " "+ mandat.vendeur_agence.last_name}}</span><span v-else>Non attribué</span>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xl2 lg2 md2 sm6 xs6>
                        <v-card tile flat>
                          <v-card-text>
                            <v-chip small :class="`chip font-weight-bold ${mandat.status}`">{{ mandat.status }}</v-chip>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      
                    </v-layout>
                  </v-card>
              </v-card>
              <v-dialog overflow-hidden v-model="dialog" :key="dialog" width="90%" height="90%">
                <app-mandat-dialog ref="appMandatDialog" v-bind:dialog="dialog" v-bind:mandat_dialog="mandatToDialog" v-bind:edit="edit" v-bind:hasBeenClosed="hasBeenClosed" 
                v-bind:creation="creation" v-bind:vendeursAgence="vendeursAgence" v-bind:vendeurs="vendeurs" v-bind:vendeursNoms="vendeursNoms"
                v-on:enableEdit="edit=false" v-on:updateMandat="actualiser_mandat($event)" v-on:mapLoaded="hasBeenClosed=false" v-on:saveEdit="save_edit($event)" 
                v-on:createMandat="create_mandat($event)" v-on:closeDialog="close_dialog()"></app-mandat-dialog>
              </v-dialog>
              <v-dialog overflow-hidden v-model="creationDialog" lazy width="90%" height="90%">
                <app-mandat-creator ref="appMandatCreator" v-bind:dialog="creationDialog" v-bind:mandat_dialog="mandatToDialog"
                  v-on:saveEdit="create_mandat($event)" v-on:closeDialog="close_creation_dialog()"></app-mandat-creator>
              </v-dialog>
              <v-dialog fullscreen v-model="mainloading">
                <app-loader />
            </v-dialog>
            </v-flex>
          </v-layout>
        </v-container>
    </v-content>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Navbar from '@/components/comps/Navbar.vue'
import Footer from '@/components/comps/Footer.vue'
import MandatDescription from '@/components/comps/MandatDescription.vue'
import MandatCreator from '@/components/comps/MandatCreator.vue'
import LoaderComponent from '@/components/comps/Loader.vue'
import router from "@/plugins/router"
import axios from 'axios'
import templates from '@/assets/templates.json'
import config from "../../config.json"
import bus from '../../main'

export default {
  name: "Mandats",
  mounted() {
    this.checkLoggedIn();
  },
  created() {
    this.mainloading=true;
    this.user=this.$session.get('user');
    console.log(this.user);
    axios({
      method : 'get',
      url: config.api.baseurl+'/api/mandats-complete',
      headers: {'Authorization': 'JWT ' + this.$session.get('token')},
      })
    .then(response => {
      // JSON responses are automatically parsed
      this.mandats = response.data;
      // sort images
      this.mandats.forEach(function(mandat){
        mandat.photos.sort((a,b)=>{return (a.position < b.position ? -1 :1) })
      });
      this.mainloading=false;
      axios({
        method : 'get',
        url: config.api.baseurl+'/api/vendeurs-agence',
        headers: {'Authorization': 'JWT ' + this.$session.get('token')},
      })
      .then(response => {
        // JSON responses are automatically parsed
        this.vendeursAgence = response.data;
        axios({
        method : 'get',
        url: config.api.baseurl+'/api/vendeurs',
        headers: {'Authorization': 'JWT ' + this.$session.get('token')},
        }).then(response => {
          this.vendeurs = response.data;
          this.vendeurs.forEach((vendeur)=>{
            this.vendeursNoms.push(vendeur.prenom + " "+vendeur.nom);
            console.log(vendeur);
          });
          this.mainloading=false;
        }).catch(e => {
          console.log(e)
        })
      })
      .catch(e => {
        this.errors.push(e)
      });
    })
    .catch(e => {
      this.errors.push(e)
    });
    
  },
  components: {
    'app-navbar' : Navbar,
    'app-footer' : Footer,
    'app-mandat-dialog' : MandatDescription,
    'app-mandat-creator' : MandatCreator,
    'app-loader' : LoaderComponent
  },
  methods: {
    checkLoggedIn() {
      this.$session.start();
      if (!this.$session.has("token")) {
        router.push("/auth");
      }else{
         axios({
          method : 'get',
          url : config.api.baseurl+'/api/user',
          headers: {'Authorization': 'JWT ' + this.$session.get('token')},
        })
        .then(response => {
          this.$session.set('user',response.data);
        }).catch(e=> {
          router.push("/auth");
        });
      }
    },
    open_dialog(mandatToDisplay) {
      this.mandatToDialog=mandatToDisplay;
      this.dialog=true;    
      this.hasBeenClosed=true;
      this.$refs.appMandatDialog.displaymap();

    },
    close_dialog(){
      
      this.edit=true;
      this.dialog=false;
      this.loading=true;
      if(this.creation==false){
        this.actualiser_mandat(this.mandatToDialog.id);
      }else{
        this.creation=false;
      }
    },
    close_creation_dialog(){
      this.edit=true;
      this.creationDialog=false;
      this.mandatToDialog=null;
      this.$nextTick().then(()=>{this.$forceUpdate()});      
    },
    save_edit(data){

      axios({
        method : 'put',
        url: config.api.baseurl+'/api/bien_update/'+this.mandatToDialog.id,
        headers: {'Authorization': 'JWT ' + this.$session.get('token')},
        data:  this.mandatToDialog
      })
      .then(response => {
      // JSON responses are automatically parsed.
        console.log(response);
        if(data.pop==true){
          var index = this.mandats.indexOf(this.mandats.find((mandat)=>mandat.id==data.bien.id));
          this.mandats.splice(index,1);
        }
      })
    .catch(e => {
      console.log(e)
    });
      this.edit=true;

      this.$nextTick().then(()=>{this.$forceUpdate()});
    },
    open_mandat_creator(){
      this.edit=false;
      const bien_template=templates['bien'];
      var new_bien = Object.create(bien_template);
      this.creation=true;    
      this.open_dialog(new_bien);
      this.hasBeenClosed=true;
      
    },
    create_mandat(){
      this.loading=true
      axios({
        method : 'post',
        url: config.api.baseurl+'/api/create-bien',
        headers: {'Authorization': 'JWT ' + this.$session.get('token')},
        data: this.mandatToDialog
      })
      .then(response => {
        this.mandatToDialog=response.data;
        //add auto setting vendeur agence
        /* essentiel pour ubiflow
        axios({
                method : 'put',
                url: '/api/bien_update_vendeur/'+this.mandatToDialog.id+'/'+vendeur.id,
                headers: {'Authorization': 'JWT ' + this.$session.get('token')},
                data: {'id': this.mandat_dialog.id, 'vendeur_agence': vendeur}
            }).then(response => {
                console.log(response.data);
                //this.mandat_dialog.vendeur_agence=vendeur;
                this.vendorPanel=false;
                this.$emit('updateMandat');
                

            }).catch(e => {
                console.log(e)
            });
        */
        this.mandats.push(this.mandatToDialog);
        this.creation=false;
        this.loading=false;
      })
      .catch(e => {
        console.log(e);
        this.loading=false;
      });
    },
    actualiser_mandat(id){
      console.log(id);
      axios({
      method : 'get',
      url: config.api.baseurl+'/api/mandat/'+id,
      headers: {'Authorization': 'JWT ' + this.$session.get('token')},
      })
    .then(response => {
      // JSON responses are automatically parsed
      var index = this.mandats.indexOf(this.mandats.find((mandat)=>mandat.id==id));
      this.mandats[index] = response.data;
      if(this.mandats[index].photos.length>1){
        this.mandats[index].photos.sort((a,b)=>{return (a.position < b.position ? -1 :1) })
      }
      this.mandats[index].photos.forEach(function(photo){
        photo.photo=photo.photo.split('/mandat/').join('/');
      });
      this.mandatToDialog = this.mandats[index];
      this.loading=false;
    })
    .catch(e => {
      this.errors.push(e)
    });
    this.$nextTick().then(()=>{this.$forceUpdate()});
    },
    pop_mandat(id){
      var index = this.mandats.indexOf(this.mandats.find((mandat)=>mandat.id==id));
      this.mandats.splice(id,1);
    },
  },
  data() {
  
 
    return{
      dialog:false,
      creationDialog:false,
      mandatToDialog:null,
      mandats:null,
      photos:null,
      mandat_drawer:false,
        ville_filter:null,
        poste_filter:null,
        poste_mask:"#####",
        types_biens:["Appartement","Maison","Terrain"],
        type_filter:[],
        budget_min:null,
        budget_max:null,
        budget_mask:"##########",
        room_min:null,
        room_max:null,
        bed_min:null,
        bed_max:null,
        room_mask:"##",
        surface_min:null,
        surface_max:null,
        surface_mask:"#####",
        user_filter:true,
      edit:true,
      hasBeenClosed:true,
      loading:false,
      mainloading:false,
      creation:false,
      mandat_backup:null,
      vendeursAgence:null,
      user:null,
      vendeurs:null,
      vendeursNoms:[],
    }
  },
};
</script>

<style>

  .mandat{
    border-bottom: 1px solid lightgray
  }
  .mandat.Simple{
    border-left: 4px solid #87CEFA
  }
  .mandat.Exclusivité{
    border-left: 4px solid #90EE90
  }
  .mandat.Accord{
    border-left: 4px solid #EB826C
  }
   .chip.Simple{
    background: #87CEFA
  }
  .chip.Exclusivité{
    background: #90EE90
  }
  .chip.Accord{
    background: #EB826C
  }
</style>